import * as React from 'react'
import { cn } from '@/app/lib/@system/utils'

/** @type {ForwardRefComponent<'label'>} */
const Label = React.forwardRef(({ className, ...props }, ref) => (
  // eslint-disable-next-line jsx-a11y/label-has-associated-control -- primitive: htmlFor/children arrive via props and are linted at every call site
  <label
    ref={ref}
    className={cn('text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70', className)}
    {...props}
  />
))
Label.displayName = 'Label'

export { Label }
